'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);


var _index = require('../../../index');
var _CellInfoIconsBlock = require('../components/CellInfoIconsBlock/CellInfoIconsBlock');var _CellInfoIconsBlock2 = _interopRequireDefault(_CellInfoIconsBlock);
var _CellPhotoBlock = require('../components/CellPhotoBlock/CellPhotoBlock');var _CellPhotoBlock2 = _interopRequireDefault(_CellPhotoBlock);

var _parkingConverter = require('../../../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);
var _isDescendant = require('../../../../utils/isDescendant');var _isDescendant2 = _interopRequireDefault(_isDescendant);

var _note = require('../../../../../static/icons/note.svg');var _note2 = _interopRequireDefault(_note);
var _OMBaseVerticalPropertyCell = require('./OMBaseVerticalPropertyCell.scss');var defaultStyles = _interopRequireWildcard(_OMBaseVerticalPropertyCell);
var _OMHomePageSliderCell = require('./OMHomePageSliderCell.scss');var sliderStyles = _interopRequireWildcard(_OMHomePageSliderCell);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var OMBaseVerticalPropertyCell = function (_Component) {_inherits(OMBaseVerticalPropertyCell, _Component);function OMBaseVerticalPropertyCell(props) {_classCallCheck(this, OMBaseVerticalPropertyCell);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_this.




































    hideNote = function (evt) {
      var isNoteIcon = _this.noteWrapper && (0, _isDescendant2.default)(_this.noteWrapper, evt.target);

      if (!isNoteIcon) {
        _this.setState({ showNote: false });
      }
    };_this.

    toggleNote = function () {return _this.setState({ showNote: !_this.state.showNote });};_this.

    renderNote = function () {return !!_this.props.propertyNote &&
      _react2.default.createElement('div', {
          className: _this.styles.noteIconWrapper,
          id: 'note_for_' + _this.props.id,
          ref: function ref(_ref) {_this.noteWrapper = _ref;} },

        _react2.default.createElement('img', {
          src: _note2.default,
          alt: '',
          className: _this.styles.noteIcon,
          onClick: _this.toggleNote }),


        _this.state.showNote &&
        _react2.default.createElement('div', { className: _this.styles.noteTooltip },
          _react2.default.createElement(_index.NoteInput, {
            value: _this.props.propertyNote,
            addNote: _this.props.addPropertyNote })));};_this.






    renderLabelNew = function () {var _this$props =
      _this.props,isRocketPromotedProperty = _this$props.isRocketPromotedProperty,isTopPromotedProperty = _this$props.isTopPromotedProperty,_this$props$showPromo = _this$props.showPromotion,showPromotion = _this$props$showPromo === undefined ? true : _this$props$showPromo;
      var shouldShowPromotion = (isRocketPromotedProperty || isTopPromotedProperty) && showPromotion;

      return _this.props.isNewProperty && !shouldShowPromotion &&
      _react2.default.createElement('div', { className: _this.styles.labelNew },
        _react2.default.createElement(_index.OMLabelNew, {
          label: _this.props.newPropertyLabel.toString(),
          title: _this.props.newPropertyTitle.toString(),
          color: '#00A6EE',
          isMobile: _this.props.isMobile }));



    };_this.

    renderLabelTop = function () {var _this$props2 =
      _this.props,isRocketPromotedProperty = _this$props2.isRocketPromotedProperty,isTopPromotedProperty = _this$props2.isTopPromotedProperty,showPromotion = _this$props2.showPromotion;

      return !isRocketPromotedProperty && isTopPromotedProperty && showPromotion &&
      _react2.default.createElement('div', { className: _this.styles.labelNew },
        _react2.default.createElement(_index.OMLabelTop, {
          label: 'TOP',
          isMobile: _this.props.isMobile }));



    };_this.

    renderRocket = function () {var _this$props3 =
      _this.props,isRocketPromotedProperty = _this$props3.isRocketPromotedProperty,showPromotion = _this$props3.showPromotion;

      return isRocketPromotedProperty && showPromotion &&
      _react2.default.createElement('div', { className: _this.styles.labelNew },
        _react2.default.createElement('i', { className: 'icon icon-top-promotion-active' },
          _react2.default.createElement('span', { className: 'path1' }),
          _react2.default.createElement('span', { className: 'path2' })),

        _react2.default.createElement('p', null, '+'),
        _react2.default.createElement('i', { className: 'icon icon-rocket-active' }));


    };_this.styles = props.isHomePageSlider ? sliderStyles : defaultStyles;_this.state = { showNote: false };return _this;}OMBaseVerticalPropertyCell.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {var propertyNote = _ref2.propertyNote;if (!propertyNote && this.props.propertyNote !== propertyNote) {this.setState({ showNote: false });}};OMBaseVerticalPropertyCell.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps, newState) {var isIdChanged = newProps.id !== this.props.id;var isPhotoChanged = newProps.photo !== this.props.photo;var isLocaleChanged = newProps.locale !== this.props.locale;var isFavoriteStateChanged = newProps.isFavorite !== this.props.isFavorite;var isShowNoteChanged = newState.showNote !== this.state.showNote;var isPropertyNoteChanged = newProps.propertyNote !== this.props.propertyNote;var isShowPromotion = newProps.showPromotion !== this.props.showPromotion;return isIdChanged || isPhotoChanged || isLocaleChanged || isFavoriteStateChanged || isShowNoteChanged || isPropertyNoteChanged || isShowPromotion;};OMBaseVerticalPropertyCell.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {if (!prevState.showNote && this.state.showNote) {document.body.addEventListener('click', this.hideNote, true);}if (prevState.showNote && !this.state.showNote) {document.body.removeEventListener('click', this.hideNote, true);}};OMBaseVerticalPropertyCell.prototype.

  render = function render() {var _props =





    this.props,neighborhood = _props.neighborhood,city = _props.city,address = _props.address,countryName = _props.countryName;

    var parkingSpots = (0, _parkingConverter2.default)(this.props.parkingSpots);
    var groundFloor = +this.props.floor === 0;
    var isMyProject = this.props.isMyProject || false;

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(this.styles.propertyRow, this.styles[this.props.additionalClassName]) },
        _react2.default.createElement(_CellPhotoBlock2.default, {
          isMyProject: isMyProject,
          locale: this.props.locale,
          isRtl: this.props.isRtl,
          isFavorite: this.props.isFavorite,
          hasVRLink: this.props.hasVRLink,
          photo: this.props.photo,
          price: this.props.price,
          currency: this.props.currency,
          toggleFavorite: this.props.toggleFavorite,
          searchOption: this.props.searchOption,
          translate: this.props.translate,
          className: this.props.isHomePageSlider ? 'homePageSliderPhoto' : 'largePhoto',
          additionalClassName: this.props.additionalClassName,
          images: this.props.images,
          videoPoster: this.props.videoPoster,
          isLazy: this.props.isLazy,
          isHomePageSlider: this.props.isHomePageSlider,
          withoutPagination: true }),


        _react2.default.createElement('div', { className: this.styles.propertyDescription },
          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: this.styles.iconsWrapper },
              this.renderNote(),
              this.renderLabelNew(),
              this.renderLabelTop(),
              this.renderRocket()),


            _react2.default.createElement('div', { className: this.styles.propertyType },
              this.props.propertyType),


            _react2.default.createElement('div', { property: 'address', className: this.styles.propertyAddress },
              _react2.default.createElement('div', { className: this.styles.address }, address),
              _react2.default.createElement('div', { className: this.styles.neighborhood },
                _react2.default.createElement('div', null,
                  neighborhood && neighborhood !== city && neighborhood + ',', ' ', !!city && city.replace(/ /g, '\xA0'))),


              _react2.default.createElement('div', null, countryName && countryName))),



          _react2.default.createElement(_CellInfoIconsBlock2.default, {
            locale: this.props.locale,
            area: this.props.area,
            floor: groundFloor ? this.props.groundFloorTitle.toString() : this.props.floor,
            floorIconTitle: this.props.floorIconTitle,
            parkingIconTitle: this.props.parkingIconTitle,
            parkingSpots: parkingSpots,
            rooms: this.props.rooms,
            roomsIconTitle: this.props.roomsIconTitle,
            squareIconTitle: this.props.squareIconTitle }))));




  };return OMBaseVerticalPropertyCell;}(_react.Component);


OMBaseVerticalPropertyCell.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  propertyType: _propTypes2.default.string,
  photo: _propTypes2.default.string,
  images: _propTypes2.default.array,
  videoPoster: _propTypes2.default.string,
  price: _propTypes2.default.number,
  address: _propTypes2.default.string,
  rooms: _propTypes2.default.number,
  parkingSpots: _propTypes2.default.object,
  city: _propTypes2.default.string,
  area: _propTypes2.default.number,
  floor: _propTypes2.default.number,
  isFavorite: _propTypes2.default.bool,
  hasVRLink: _propTypes2.default.bool,
  isNewProperty: _propTypes2.default.bool,
  isTopPromotedProperty: _propTypes2.default.bool,
  isRocketPromotedProperty: _propTypes2.default.bool,
  propertyNote: _propTypes2.default.string,
  parkingIconTitle: _propTypes2.default.func,
  roomsIconTitle: _propTypes2.default.func,
  floorIconTitle: _propTypes2.default.func,
  squareIconTitle: _propTypes2.default.func,
  groundFloorTitle: _propTypes2.default.func,
  newPropertyTitle: _propTypes2.default.func,
  newPropertyLabel: _propTypes2.default.func,
  topPropertyLabel: _propTypes2.default.func,
  addPropertyNote: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  searchOption: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  isHomePageSlider: _propTypes2.default.bool,
  isLazy: _propTypes2.default.bool,
  currency: _propTypes2.default.string,
  countryName: _propTypes2.default.string,
  isMyProject: _propTypes2.default.bool,
  neighborhood: _propTypes2.default.string,
  showPromotion: _propTypes2.default.bool,
  additionalClassName: _propTypes2.default.string };exports.default =


OMBaseVerticalPropertyCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMBaseVerticalPropertyCell/OMBaseVerticalPropertyCell.js
// module id = 1218
// module chunks = 0